/**
 * Múltiples Viajes es SIEMPRE un año.
 *
 * No es un rango que el cliente elija: es lo que se contrata. El producto viene
 * marcado con dateType 'date' —una sola fecha, la de salida— y la llegada se
 * deriva de ella.
 *
 * El bug que trajo esto: se cotizaba Viajes Puntuales del 01/09 al 29/09 y al
 * EDITAR se cambiaba el producto a Múltiples Viajes; las fechas del viaje
 * puntual sobrevivían al cambio, porque el recálculo solo ocurría al tocar el
 * calendario. Rastro real: tuchelada@yahoo.com.
 *
 * ⚠️ REGLA DUPLICADA CON EL API: el mismo cálculo vive en
 * `api/src/common/multiples-viajes.util.ts`, que es el candado que impide que
 * llegue un rango malo por cualquier otra vía (Flow de WhatsApp, voz,
 * integraciones). Son dos runtimes y no pueden compartir código. Si se cambia
 * una, hay que cambiar la otra o el widget enseñará un rango y se guardará otro.
 */

/**
 * Días que se SUMAN a la salida. 364 y no 365: con la cuenta canónica —ambos
 * extremos cuentan— salida + 364 son exactamente 365 días de cobertura.
 */
export const DIAS_MULTIPLES_VIAJES = 364;

/** ¿Este producto se cotiza con una sola fecha, es decir, es el anual? */
export function esProductoAnual(dateType) {
  return dateType === 'date';
}

/** La llegada que le corresponde a una salida. Devuelve Date, o null. */
export function finDeMultiplesViajes(salida) {
  if (!salida) return null;
  const base = salida instanceof Date ? salida : new Date(salida);
  if (isNaN(base.getTime())) return null;

  const fin = new Date(base.getTime());
  fin.setDate(fin.getDate() + DIAS_MULTIPLES_VIAJES);
  return fin;
}

/**
 * ¿Son el mismo día? Se compara por día y no por igualdad de Date para que el
 * efecto que mantiene la invariante no entre en bucle: dos Date del mismo día
 * creados en instantes distintos nunca son ===.
 */
export function mismoDia(a, b) {
  if (!a && !b) return true;
  if (!a || !b) return false;
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}
